import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store/store'

interface NotificationState {
  showNotify: boolean
}

const initialState: NotificationState = {
  showNotify: true,
}

// Slice
const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setShowNotify: (state, action: PayloadAction<boolean>) => {
      const { payload } = action
      state.showNotify = payload
    },
  },
})

// Selectors
export const getShowNotifySelector = (state: RootState): boolean =>
  state.notification.showNotify

// Actions
export const { setShowNotify } = notificationSlice.actions

// Reducers
export default notificationSlice.reducer
